import { isNull } from "./util";

export function isValidNull(data, id) {
  if (isNull(data)) {
    focusFormField(id);
    return false;
  }
  return true;
}

export function focusFormField(id) {
  document.querySelector(`#${id}`).focus();
}

export function isValidPhoneNumber(phone, id) {
  const phoneRegex = /^\d{3}\d{3,4}\d{4}$/;
  if (!phoneRegex.test(phone)) {
    focusFormField(id);
    return false;
  }
  return true;
}

export function isValidEmail(email, id) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    focusFormField(id);
    return false;
  }
  return true;
}

export function isValidNumber(value) {
  return !isNaN(value);
}